import { useGetPartnersQuery, type Partner } from '@/api/partners.api'

/** Returns the current user's partner (first in the list — the API restricts by role). */
export function useMyPartner(): {
  partner: Partner | undefined
  isLoading: boolean
  error: unknown
} {
  const { data, isLoading, error } = useGetPartnersQuery()
  return { partner: data?.items[0], isLoading, error }
}
